// extracted by mini-css-extract-plugin
export default {"aboutme":"Aboutme_aboutme__auiwB","about":"Aboutme_about__2zvGP","Emoji":"Aboutme_Emoji__r-itn","floating":"Aboutme_floating__hOQjP"};